import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Cuenta creada con éxito");
      nav("/account");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="register-page" className="pt-28 min-h-screen flex items-center justify-center p-8">
      <div className="w-full max-w-md">
        <p className="overline mb-3">Crear cuenta</p>
        <h1 className="font-heading text-4xl text-ivory mb-10">Únase a la Maison</h1>
        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="luxe-label">Nombre completo</label>
            <input data-testid="register-name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="luxe-input" />
          </div>
          <div>
            <label className="luxe-label">Email</label>
            <input data-testid="register-email" type="email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="luxe-input" />
          </div>
          <div>
            <label className="luxe-label">Contraseña (mín. 6 caracteres)</label>
            <input data-testid="register-password" type="password" minLength={6} required value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="luxe-input" />
          </div>
          <button type="submit" disabled={loading} data-testid="register-submit" className="btn-gold w-full disabled:opacity-50">
            {loading ? "Creando..." : "Crear cuenta"}
          </button>
        </form>
        <p className="text-center mt-8 text-sm text-ivory/60">
          ¿Ya tiene cuenta? <Link to="/login" className="text-gold link-underline">Iniciar sesión</Link>
        </p>
      </div>
    </div>
  );
}
